<template>
  <div class="card">
    <div class="card-header">
      <h5>{{ $t('promo.self_plural') }}</h5>
    </div>
    <div class="card-body">
      <a-button
        class="mb-3"
        type="link"
        icon="plus"
      >
        <router-link to="promo/new">
          {{ $t('promo.create_new') }}
        </router-link>
      </a-button>
      <a-table
        row-key="id"
        :loading="loading"
        :data-source="promoCodes"
        :columns="columns"
        :pagination="pagination"
        bordered
      >
        <template
          slot="status"
          slot-scope="active"
        >
          <a-tag
            v-if="active"
            color="green"
          >
            {{ $t('promo.active') }}
          </a-tag>
          <a-tag
            v-else
            color="red"
          >
            {{ $t('promo.inactive') }}
          </a-tag>
        </template>
        <template
          slot="period"
          slot-scope="_, row"
        >
          <span>{{ row.dateBegin | dateFormatter('DD-MM-YYYY HH:mm') }} - {{ row.dateEnd| dateFormatter('DD-MM-YYYY HH:mm') }}</span>
        </template>
        <template
          slot="type"
          slot-scope="type"
        >
          <span v-if="type === 'PERCENTAGE'">{{ $t('promo.percent') }}</span>
          <span v-else-if="type === 'FIXED'">{{ $t('promo.fixed') }}</span>
        </template>
        <template
          slot="value"
          slot-scope="text, row"
        >
          <span v-if="row.type === 'PERCENTAGE'">{{ `${text} %` }}</span>
          <span v-else-if="row.type === 'FIXED'">{{ text | money }}</span>
        </template>
        <template
          slot="actions"
          slot-scope="id, row"
        >
          <router-link :to="`promo/${id}`">
            <a-button
              class="mr-2"
              icon="eye"
              variant="light"
            />
          </router-link>
          <a-popconfirm
            v-if="row.active"
            :title="`${$t('promo.deactivate')}?`"
            @confirm="handleDeactivate(id)"
          >
            <a-button
              icon="poweroff"
              variant="light"
            />
          </a-popconfirm>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import PromoCodeService from '@/services/api/manager/promo-code-service'

export default {
  name: 'PromoCodes',
  data() {
    return {
      promoCodes: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 30,
        total: 0,
      },
      columns: [
        {
          title: '№',
          dataIndex: 'id',
          width: '50px',
        },
        {
          title: this.$t('promo.self'),
          dataIndex: 'codeString',
        },
        {
          title: this.$t('promo.discount_type'),
          dataIndex: 'type',
          scopedSlots: {
            customRender: 'type',
          },
        },
        {
          title: this.$t('promo.discount_value'),
          dataIndex: 'discountValue',
          scopedSlots: {
            customRender: 'value',
          },
        },
        {
          title: this.$t('promo.period'),
          dataIndex: 'period',
          scopedSlots: {
            customRender: 'period',
          },
        },
        {
          title: this.$t('promo.status'),
          dataIndex: 'active',
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          width: '120px',
          dataIndex: 'hashId',
          scopedSlots: {
            customRender: 'actions',
          },
        },
      ],
    }
  },

  mounted() {
    this.getPromoCodes()
  },

  methods: {
    getPromoCodes() {
      this.loading = true
      PromoCodeService.getCodes(this.pagination)
        .then(response => {
          this.promoCodes = response.data.content
          this.pagination.total = response.data.pagination.total
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleDeactivate(id) {
      PromoCodeService.deactivateCode(id)
        .then(() => {
          this.getPromoCodes()
        })
    },
  },
}
</script>
